import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["image", "fallback"]

    connect() {
        if (this.hasImageTarget && this.imageTarget.complete && this.imageTarget.naturalWidth === 0) {
            this.useFallback()
        }
    }

    useFallback() {
        if (this.hasImageTarget) this.imageTarget.classList.add("hidden")
        if (this.hasFallbackTarget) this.fallbackTarget.classList.remove("hidden")
    }
}
